import React, { useEffect, useState } from 'react';
import * as core from 'cw-ui-core';
import css from './ApproveImportedUserDialog.scss';
import Locale from 'src/i18n';

export const APPROVE_IMPORTED_USER_DIALOG = 'APPROVE_IMPORTED_USER_DIALOG';

const ApproveImportedUserDialog = props => {
    const [authMethodValue, setAuthMethodValue] = useState('');
    const [isApproveButtonDisable, setIsApproveButtonDisable] = useState(true);

    const { onWillMount } = props;
    useEffect(() => {
        onWillMount();
    }, [onWillMount]);

    const onAuthMethodChange = item => {
        setAuthMethodValue(item.id);
        if (item.name.toLowerCase() !== 'select a method') {
            setIsApproveButtonDisable(false);
        }
        props.onLoginProviderChange(item);
    };

    const dialogButtons = [
        <core.ButtonLight
            key="cancel"
            automationName="cancel"
            className={css.cancelButton}
            value={core.formatMessage(Locale.cancel)}
            onClick={props.onCancelButtonClick}
        />,
        <core.ButtonStandard
            key="approve"
            automationName="approve"
            className={css.approveButton}
            value={core.formatMessage(Locale.invite)}
            onClick={props.onApproveButtonClick}
            disabled={isApproveButtonDisable}
        />,
    ];

    return (
        <core.Dialog
            dialogId={APPROVE_IMPORTED_USER_DIALOG}
            header={core.formatMessage(Locale.selectAuthenticationMethod)}
            buttons={dialogButtons}
            className={css.approveImportedUsersDialog}>
            <core.Label
                value={core.formatMessage(Locale.setAuthenticationMethod)}
                grey7
                className={css.authMethodText}
            />
            <core.ComboBox
                cwId="providersDropDown"
                automationName="providersDropDown"
                value={authMethodValue}
                items={props.loginProviders}
                expandOnClick
                readOnly
                onChange={onAuthMethodChange}
                placeholder={core.formatMessage(Locale.selectAMethod)}
            />
        </core.Dialog>
    );
};

export default ApproveImportedUserDialog;
